import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconArrowLeft } from '@sorare/core/src/atoms/icons/system/iconArrowLeft.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { range } from '@sorare/core/src/lib/arrays.ts';

import { ProgressBar } from './ProgressBar/index.tsx';

const Root = styled(Horizontal)`
  position: relative;
  width: 100%;
`;
const ProgressBarsWrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: var(--unit);
`;

type Props = {
  noBackButton?: boolean;
  onBack?: () => void;
  progress: number | null;
  color: string;
};
export const OnboardingStepLayoutHeader = ({
  noBackButton,
  onBack,
  progress,
  color,
}: Props) => {
  const progresses = typeof progress === 'number' ? range(4) : [];

  return (
    <Root>
      {!noBackButton && (
        <IconButton
          size="medium"
          onClick={onBack}
          icon={iconArrowLeft}
          color="quaternary"
        />
      )}
      {typeof progress === 'number' && (
        <ProgressBarsWrapper>
          {progresses.map((p, i) => (
            <ProgressBar
              // oxlint-disable-next-line react/no-array-index-key
              key={i}
              progress={i < progress ? 100 : 0}
              color={color}
            />
          ))}
        </ProgressBarsWrapper>
      )}
    </Root>
  );
};
